import actions from '@/core/store/documentos/processo-digital/desentranhamento/actions'

export default {
	actions,
}
